import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SegmentClassSPArrayModel, SegmentClassSPModel } from "../../models/SegmentClassSPModel";

const initialSegmentClassSPState: SegmentClassSPArrayModel = {
    particular_segmentClassSP: {
        "segmentClassId": 0,
        "name": ""
    }
}
const SegmentClassSPSlice = createSlice({
    name: 'SegmentClassSP',
    initialState: initialSegmentClassSPState,
    reducers: {
        setParticularSegmentClassSP(state, action: PayloadAction<SegmentClassSPModel>) {
            state.particular_segmentClassSP = action.payload;
        }
    }
})
export default SegmentClassSPSlice;